import { Image } from './lib/image.js';
customElements.define('cipublic-image', Image);
//# sourceMappingURL=cipublic-image.js.map